export const STATUS_COMPANY = {
   unblock: 'UNBLOCK',
   block: 'BLOCK',
   terminate: 'TERMINATE',
};

export const LOGIN_TYPE = {
   normal: 'normal',
   google: 'google',
};

export const initialSelectedPhoneCountry = {
   countryId: 243,
   nameCode: 'VNM',
   alpha2Code: 'VN',
   alpha3Code: 'VNM',
   countryName: 'Vietnam',
   numericCode: 704,
   phoneRegex: /^\\+?84[0-9]{6,}$|^[0-9]{9,11}$/,
   callingCode: '+84',
   placeHolder: '912345678',
   nationFlag:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAPBAMAAAD9gUllAAAAMFBMVEXaJR2xV1P//wDmbRP64gS1W1fcNBv87QLjXRbztQr30AajdXO8Yl7pehLvnw3xrQuIO9JfAAAAQElEQVQI12NAAgeQOQHIHAEIxYzMYUJWZmQAl+FwLyrxgCvLUtJKgHOYlZQRBnD6eiI4/Al8EA4UEOIECsLBBgDKjAga/3ggfgAAAABJRU5ErkJ\r\n',
   createdBy: '1',
   createdTime: '2023-06-07 16:54:59',
   modifiedBy: '1',
   modifiedTime: '2024-08-14 10:32:35',
};

export const COMPANY_RANGE = [
   { value: '1-10', display: '1-10' },
   { value: '11-20', display: '11-20' },
   { value: '21-50', display: '21-50' },
   { value: '51-100', display: '51-100' },
   { value: '100+', display: '100+' },
];

export const INIT_PERSONAL_INFO = {
   personalNumber: '',
   fullName: '',
   birthDate: '',
   gender: '',
   nationality: '',
   ethnic: '',
   religion: '',
   placeOfOrigin: '',
   placeOfResidence: '',
   personalIdentification: '',
   issuancePlace: '',
   issuanceDate: '',
   expiryDate: '',
   idDocument: '',
   fullNameOfParents: '',
   fullNameOfSpouse: '',
   passportNumber: '',
   documentType: '',
   placeOfBirth: '',
   mrz: '',
   image: '',
};

export const INIT_TAX_INFO = {
   taxId: '',
   fullName: '',
   officialName: '',
   issuanceDate: '',
   address: '',
};

export const ACCOUNT_MODES = {
   none: 0,
   personalInfo: 1,
   taxInfo: 2,
};

export const ACCOUNT_CONFIGS = {
   personalInfo: [
      { key: 'fullName', title: 'common.full-name', className: 'col-span-full' },
      { key: 'birthDate', title: 'common.content-129', className: '' },
      { key: 'gender', title: 'common.content-130', className: '' },
      { key: 'personalNumber', title: 'common.content-131', className: 'col-span-full' },
      { key: 'ethnic', title: 'common.content-132', className: '' },
      { key: 'nationality', title: 'common.content-133', className: '' },
      { key: 'placeOfOrigin', title: 'common.content-134', className: 'col-span-full' },
      { key: 'placeOfResidence', title: 'common.content-135', className: 'col-span-full' },
      { key: 'issuanceDate', title: 'common.content-136', className: '' },
      { key: 'expiryDate', title: 'common.content-137', className: '' },
   ],
   taxInfo: [
      { key: 'taxId', title: 'common.content-139', className: 'col-span-full' },
      { key: 'officialName', title: 'common.content-140', className: 'col-span-full' },
      { key: 'issuanceDate', title: 'common.content-136', className: 'col-span-full' },
      { key: 'address', title: 'common.content-141', className: 'col-span-full' },
      { key: 'fullName', title: 'common.content-142', className: 'col-span-full' },
   ],
};

export const MODE = process.env.REACT_APP_MODE || 'development';

export const CHECK_ID_URLS = {
   // using for DEV env
   gw: 'https://download.mobile-id.vn/download/CheckId-Clientv2/checkid_client_installer.exe',
   // using for PRD env
   uat: 'https://download.mobile-id.vn/download/CheckId-Clientv2/prd/checkid_client_installer.exe',

   live: 'https://checkid.mobile-id.vn/plugin/v2/checkid_client_installer.exe',
};

export const CHECK_ID_URL = MODE === 'development' ? CHECK_ID_URLS.gw : CHECK_ID_URLS.uat;


export const USER_STATUS = {
   none: 'NONE',
   block: 'BLOCK',
   unblock: 'ACTIVE',
   terminate: 'TERMINATE',
   pendingActivation: 'PENDING_ACTIVATION',
};

export const DATE_FORMAT = {
   yyyyMMdd: 'yyyy-MM-dd',
};

export const ROLES = {
   Auditor: 'AUDITOR',
   Employee: 'EMPLOYEE',
   Admin: 'ADMIN',
   Subscription: 'SUBCRIPTION',
};

export const EVENT_STATUS = {
   ok: 0,
   missingCheckInOut: 1,
};
